import React, { useMemo, useState } from "react";
import moment from "moment";

function Comment({ comment }) {
  return (
    <div
      className="p-2"
      style={{
        fontSize: "0.8rem",
        backgroundColor: comment.comment_state?.color,
      }}
    >
      <span className="text-primary">
        {moment(comment.created_at).format("YYYY MM DD [\n] HH:mm")}
      </span>
      <br />
      <span className="font-weight-bold">
        {comment.user_title + " - " + comment.comment_state?.name}
      </span>
      {comment.date !== null && (
        <>
          <br />
          <span className="font-weight-bold">
            {moment(comment.date).format("YYYY MM DD")}
          </span>
        </>
      )}
      <br />
      <p style={{ whiteSpace: "pre-wrap" }}>{comment.body}</p>
    </div>
  );
}

function TableComment({ comments = [], type }) {
  const [showMore, setShowMore] = useState(false);

  const filteredComments = useMemo(() => {
    return comments
      .filter((comment) => comment.comment_type === type)
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  }, [comments.length]);

  const urgentComment = useMemo(() => {
    if (type !== "comment_management") return null;
    if (!(filteredComments.at(-1)?.comment_state?.name == "Ordered"))
      return null;

    const last = filteredComments.filter(
      (comment) => comment?.comment_state?.name !== "Ordered"
    ).at(-1);

    if (!last || last?.comment_state?.name !== "The customer needs to be informed")
      return null;
    return last.body;
  }, [filteredComments.length]);

  if (filteredComments.length === 0) {
    return (
      <td className="align-middle">
        <div style={{ width: 220 }} />
      </td>
    );
  }

  if (filteredComments.length === 1) {
    const comment = filteredComments.at(0);
    return (
      <td
        className="align-middle"
        style={{
          backgroundColor: comment.comment_state?.color,
        }}
      >
        <div style={{ width: 220 }}>
          <Comment comment={comment} />
        </div>
      </td>
    );
  }

  const renderComments = (commentList) =>
    commentList.map((comment) => (
      <Comment key={comment.id} comment={comment} />
    ));

  const showMoreButton = (
    <button
      className="btn btn-sm btn-primary"
      style={{
        padding: "0",
        width: "100%",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      }}
      onClick={() => setShowMore(!showMore)}
    >
      <span style={{ fontSize: "0.8rem", fontWeight: "400" }}>
        {showMore ? "Hide" : "Show"} older
      </span>
    </button>
  );

  return (
    <td
      className={`align-middle ${
        !!urgentComment ? "border border-danger" : ""
      }`}
    >
      <div style={{ width: 220 }}>
        {showMoreButton}
        {showMore
          ? renderComments(filteredComments)
          : renderComments(filteredComments.slice(-1))}

        {!showMore && !!urgentComment && (
          <div className="text-danger">{urgentComment}</div>
        )}
      </div>
    </td>
  );
}

export default TableComment;
